import gql from 'graphql-tag'

export const GetAmazonCategory = gql`
  query getAmazonCategory($categoryId: Int!) {
    amazon_category(id: $categoryId)
  }
`